import { createSlice } from "@reduxjs/toolkit";
import { bookMarkData } from "../../../Data/LayoutData/HeaderData"; // Importing initial bookmark data
import {
  BookmarkSliceType,
  BookmarkedDataType,
} from "../../../Types/Layout/SidebarType"; // Importing TypeScript types for the state

// Initial state of the bookmark slice
const initialState: BookmarkSliceType = {
  bookmarkedData: [...bookMarkData], // Set initial bookmarked data from the imported bookmark data
  linkItemsArray: [], // An array to store dynamic link items that might be updated
};

// Creating the slice to manage the bookmark-related state
const bookmarkSlice = createSlice({
  name: "BookmarkSlice", // The name of the slice
  initialState, // The initial state defined above
  reducers: {
    // Action to update the linkItemsArray with the provided payload
    getLinkItemsArray: (state, action) => {
      state.linkItemsArray = action.payload; // Set the linkItemsArray with the provided data
    },

    // Action to handle adding or removing bookmarks
    handleBookmarkChange: (state, action) => {
      // If the bookmark is not already set (bookmarked is false), add it to the bookmarkedData
      if (!action.payload.bookmarked) {
        state.bookmarkedData.push({
          ...action.payload,
          bookmarked: !action.payload.bookmarked,
        });
      } else {
        // If it's already bookmarked, remove it from the bookmarkedData array
        const tempt: BookmarkedDataType[] = [];
        state.bookmarkedData.forEach((ele) => {
          if (ele.id !== action.payload.id) {
            tempt.push(ele); // Push all elements that don't match the id of the payload
          }
        });
        state.bookmarkedData = tempt; // Update bookmarkedData with the new array
      }

      // Update the linkItemsArray with the modified bookmark status
      const temp = [...state.linkItemsArray]; // Create a copy of linkItemsArray
      temp.splice(action.payload.id - 1, 1, {
        ...action.payload,
        bookmarked: !action.payload.bookmarked,
      }); // Update the specific item by ID
      state.linkItemsArray = temp; // Set the modified array back to linkItemsArray
    },
  },
});

// Export the actions for dispatching in components
export const { getLinkItemsArray, handleBookmarkChange } =
  bookmarkSlice.actions;

// Export the reducer to be used in the Redux store
export default bookmarkSlice.reducer;
